<template>
  <div class="uploader-success">
    <div class="uploader-success-mark" aria-hidden="true">✓</div>
    <h2>{{ $t('submitted_thanks') }}</h2>
    <p>{{ $t('submitted_email_send') }}</p>
    <div
      class="alert-uploader"
      role="alert"
      v-html="this.$t('check_spam_info')"
    />

    <div class="uploader-actions">
      <button type="button" class="btn-uploader" @click="finish_preview">
        {{ $t('new_preview') }}
      </button>
    </div>
  </div>

</template>

<script>
    export default {
        name: "StepFive",
        mounted() {
            const vm = this;
            this.$nextTick(() => {
                vm.$emit('scroll-to-app');
            });
        },
        methods: {
            finish_preview: function() {
                const vm = this;
                vm.$emit('scroll-to-app');
                vm.$emit("finish-preview");
            }
        }
    }
</script>

<style scoped>

</style>
